import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  color?: string;
};
const MyDealsIcon: FC<Props> = ({ color = colors['--label'] }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 16.25H26.25M3.75 16.25V21.75C3.75 22.8546 4.64543 23.75 5.75 23.75H24.25C25.3546 23.75 26.25 22.8546 26.25 21.75V16.25M3.75 16.25L5.87127 7.76493C6.09385 6.87459 6.89382 6.25 7.81155 6.25H10M26.25 16.25L24.1287 7.76493C23.9061 6.87459 23.1062 6.25 22.1884 6.25H20M7.5 20H8.75"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3.75V12.5M15 12.5L17.5 10M15 12.5L12.5 10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MyDealsIcon;
